import React, { useEffect, useState } from 'react';
import { Checkbox, Input, Radio } from '@mui/material';
//https://reactjs.org/docs/hooks-overview.html
export const useCheckBoxStateHandler =(mqt_answer_type) => {
    const [selectedAnswers,setSelectedAnswers] = useState({});

    const onClick = (qID,aID,isChecked) => {
        const selectedAnswersTemp = JSON.parse(JSON.stringify(selectedAnswers));
        if(mqt_answer_type){
            if(mqt_answer_type === 'checkbox'){
                if(!selectedAnswersTemp[qID]){
                    selectedAnswersTemp[qID] = [];
                }
                if(selectedAnswersTemp[qID].includes(aID)){
                    if(!isChecked)
                    selectedAnswersTemp[qID].splice(selectedAnswersTemp[qID].indexOf(aID),1);
                }else{
                    if(isChecked)
                    selectedAnswersTemp[qID].push(aID);
                }
                
            }else{
               
                selectedAnswersTemp[qID] = [];
                selectedAnswersTemp[qID].push(aID);
                      
            }
        }
        
        setSelectedAnswers(selectedAnswersTemp);
    }

    return [selectedAnswers,onClick];
}

export default function MQTSelectBox(props){
    const [checked,setChecked] = useState(props.checked);

    useEffect(()=>{
        setChecked(props.checked);

    },[props.checked]);

    function onElemClick(event){
        props.onClick(event.target.checked)
    }

    return <div key={props.questionID+"_"+props.value} className='' >
    {props.type === "radio" ? 
        <Radio
        checked={props.checked}
        onChange={onElemClick}
        className="mqt-radio"
        sx={{

            "&.Mui-checked .MuiSvgIcon-root": {
            color: "#ba0c2f", // Checked color
            },
        }}
        />
    : null}
    {props.type === "checkbox" ? 
        
        <Checkbox sx={{
            color: "#ba0c2f", // Default color (unchecked)
            "&.Mui-checked": {
              color: "#ba0c2f", // Checked color
            },
            width: "fit-content",
          }} checked={props.checked} onChange={onElemClick} 
           className='mqt-checkbox-container'/>
    : null}
    {/* <input checked={this.props.checked} type={this.props.type} className='mqt-checkbox-container' onClick={this.onElemClick} ></input> */}
</div>
}